<template>
  <div>
    <div v-for="(item, index) in items" :key="`re-item-${index}`">
      <div class="period-panel py-3 rounded">
        <div class="row">
          <div class="col d-flex flex-row justify-content-start">
            <custom-icon-view
              icon="fa fa-calendar"
              icon-color="#fff"
              icon-background="#FF7058"
              gradient
              variant="d-inline w-auto"
              :width="''"
            />
            <strong
              class="d-block font-18 font-weight-bold mt-0 ml-n4 d-flex align-items-center"
            >
              Año Académico {{ item.academicYear }}
            </strong>
          </div>
        </div>
      </div>
      <ReferralEvaluationRow
        v-for="(evaluation, ix) in item.evaluations"
        :key="`eval-item-${ix}`"
        :alt="ix % 2 === 0"
        :items-eval="evaluation"
        @on-delete="$emit('on-delete', evaluation)"
        @on-enter="$emit('on-enter', $event)"
        @on-download-referral-report="$emit('on-download-referral-report', $event)"
      />
    </div>
  </div>
</template>

<script>
import ReferralEvaluationRow from './ReferralEvaluationRow';
import CustomIconView from '@/components/common/CustomIconView.vue';
export default {
  name: 'ReferralEvaluationItem',
  components: {
    ReferralEvaluationRow,
    CustomIconView,
  },
  props: {
    items: { type: Array, required: true },
  },
  data: () => ({}),
};
</script>

<style scoped>
.re-header {
  color: #ffffff;
  padding-left: 20px;
  font: 900 16px Lato;
  padding-bottom: 15px;
  background-color: #3f5b60;
  border-radius: 5px 5px 0px 0px;
}
.re-subheader {
  background: #e7ebe9 0% 0% no-repeat padding-box;
  font: 900 16px Lato;
  color: #11291b;
  height: 40px;
  padding-left: 15px;
  padding-top: 10px;
}
.period-panel {
  background: #e2e2e2 0% 0% no-repeat padding-box;
  opacity: 1;
  padding: 10px 0px 20px 20px;
}
</style>
